import { Instance, SnapshotOut, types } from 'mobx-state-tree'
import { v4 as nanoid } from 'uuid'
import { extendLogger, LoggerContexts } from '../../utils/logger'
import { ChannelModel, ChannelModelType } from '../api-store'
import { withRootStore } from '../extensions'

const logger = extendLogger(LoggerContexts.ChannelStore)

/**
 * A SessionChannelStore model.
 */
export const ChannelStoreModel = types
  .model('ChannelStoreModel')
  .props({
    channel: types.maybe(ChannelModel)
  })
  .extend(withRootStore)
  .actions((self) => ({
    clearChannel() {
      self.channel = undefined
    },
    setChannel(data: ChannelModelType) {
      self.channel = data
    }
  }))
  .actions((self) => ({
    joinChannel(channelName: string) {
      const userId = self.rootStore.session.user?._id
      if (userId) {
        try {
          const createdChannel = ChannelModel.create({ channelName: channelName, _id: `${channelName}-${nanoid()}` })
          if (ChannelModel.is(createdChannel)) {
            self.setChannel(createdChannel)
          }
        } catch (error) {
          logger.error('joinChannel', error)
          throw error
        }
      }
    },
    async deleteGame(gameId: string) {
      try {
        const args = { id: gameId }
        await self.rootStore.api.mutateDeleteGame(args)
      } catch (error) {
        logger.error('deleteGameId', error)
        throw error
      }
    },
    async terminateGame(gameId: string, userId: string) {
      try {
        const args = { id: gameId, userId }
        await self.rootStore.api.mutateTerminateGame(args)
        // NOTE: tearDown() here will clear everything and the Game deleted event won't be received
        // DEPRECATED: self.rootStore.game.teardown()
      } catch (error) {
        logger.error('terminate GameId', error)
        throw error
      }
    }
  }))

/**
 * The ChannelStore instance.
 */
export type ChannelStoreType = Instance<typeof ChannelStoreModel>

/**
 * The data of a ChannelStore.
 */
export type ChannelStoreSnapshot = SnapshotOut<typeof ChannelStoreModel>
